import React, { useEffect, useState } from 'react';
import { NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import Session from './Session';
import AuthFunctions from '../services/AuthService';

export const HeaderLoginMenu = () => {
    const [token, setToken] = useState(Session.getToken());
    const [userName, setUserName] = useState(Session.getUserName());
    const [isAdmin, setIsAdmin] = useState(false);

    // NEW: mail redirect flag
    const [mailRedirectEnabled, setMailRedirectEnabled] = useState(false);

    const isLoggedIn = !!token && !!userName;

    useEffect(() => {
        let alive = true;

        const refreshSession = () => {
            if (!alive) return;
            setToken(Session.getToken());
            setUserName(Session.getUserName());
        };

        const id = window.setInterval(refreshSession, 500);

        const onStorage = (e) => {
            if (
                e.key === 'token' ||
                e.key === 'userName' ||
                e.key === 'userId' ||
                e.key === 'usersRole'
            ) {
                refreshSession();
            }
        };

        window.addEventListener('storage', onStorage);
        refreshSession();

        return () => {
            alive = false;
            window.clearInterval(id);
            window.removeEventListener('storage', onStorage);
        };
    }, []);

    useEffect(() => {
        let alive = true;

        const run = async () => {
            if (!isLoggedIn) {
                if (alive) setIsAdmin(false);
                return;
            }

            try {
                const ok = await AuthFunctions.isAdminAsync();
                if (alive) setIsAdmin(!!ok);
            } catch {
                if (alive) setIsAdmin(false);
            }
        };

        run();

        return () => {
            alive = false;
        };
    }, [isLoggedIn, token]);

    // NEW: load system flags once
    useEffect(() => {
        let alive = true;

        const loadFlags = async () => {
            try {
                const r = await fetch('/api/System/Flags');
                if (!r.ok) return;

                const data = await r.json();

                if (alive) {
                    setMailRedirectEnabled(!!data.mailRedirectEnabled);
                }
            } catch {
                // ignore errors silently
            }
        };

        loadFlags();

        return () => {
            alive = false;
        };
    }, []);

    if (!isLoggedIn) {
        return <></>;
    }

    return (
        <>
            {/* NEW: visible warning badge */}
            {isAdmin && mailRedirectEnabled && (
                <NavItem
                    className="navbar-text mr-3"
                    style={{
                        color: 'red',
                        fontWeight: 'bold'
                    }}
                >
                    MAIL REDIRECT ON
                </NavItem>
            )}

            <NavItem className="navbar-text mr-2">
                Hello, {userName}
            </NavItem>

            {isAdmin && (
                <NavItem className="mr-2">
                    <NavLink tag={Link} className="text-dark" to="/admin">
                        Admin
                    </NavLink>
                </NavItem>
            )}

            <NavItem>
                <NavLink tag={Link} className="text-dark" to="/logout">
                    Logout
                </NavLink>
            </NavItem>
        </>
    );
};